<div class="mech-diag-content">
	<app-dvs-chart [error]="errormessage" [options]="tsoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="spectrumoptions"></app-dvs-chart>
	<div class="ordercheck">
		<label class="form-check-label">
			<input [(ngModel)]="useorder" (ngModelChange)="UpdateChart()" class="form-check-input" type="checkbox">
			Display in orders
		</label>
	</div>
</div>